import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { v4 as uuid } from 'uuid';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TabsUi } from '../../components/UI/TabsUi/TabsUI';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import TooltipUI from '../../components/UI/Tooltip/Tooltip';

import {
  actionProps,
  inspecionarProcessoPageController as controller,
} from './inspecaoProcessoController';
import { loadingInspecaoProcessoController as loadingController } from './loadingInspecaoProcessoController';

import { Historico } from './Historico/Historico';
import {
  ActionButton,
  ActionButtonGroup,
  ActionContainer,
  ActionContentContainer,
  AdditionalInfoContainer,
  Container,
  FooterInspecionar,
  MainContainer,
} from './InspecionarProcessoStyles';
import { AcompanhamentoProcesso } from './Acompanhamento/Acompanhamento';
import { DadosDevedorProcesso } from './DadosDevedor/DadosDevedor';
import { DadosClienteProcesso } from './DadosCliente/DadosCliente';
import { TitulosProcesso } from './Titulos/Titulos';
import { FaseProcesso } from './Fase/Fase';

import { initializePageAction } from '../../store/theme.actions';
import { PreferenciasProcesso } from './PreferenciasProcesso/PreferenciasProcesso';
import SinalizacaoCores from './Sinalizacao/Cores/SinalizacaoCores';
import SinalizacaoAlertas from './Sinalizacao/Alertas/SinalizacaoAlertas';
import SinalizacaoIcones from './Sinalizacao/Icones/SinalizacaoIcones';
import { AntecedenteProcesso } from './AntecendentesProcesso';
import ButtonUI from '../../components/UI/Button/ButtonUI';
import { DocumentosProcesso } from './DocumentosProcesso/DocumentosProcesso';
import { ListaRecalculoProcesso } from '../../components/ListaRecalculoProcesso/ListaRecalculoProcesso';
import Acordos from './Acordos/Acordos';
import {
  buscarIdFaseAcordoSeguro,
  buscarIdFaseBaixa,
} from '../../services/core/fase/fase.services';
import { FichaFinanceira } from './FichaFinanceira/FichaFinaceira';
import { DadosJuridicos } from './DadosJuridicos/DadosJuridicos';
import TabCardLayout from '../../layouts/TabCardLayout/v2/TabCardLayout';
import TabModel from '../../models/TabModel';
import TabPanel from '../../components/UI/TabPanel/TabPanel';
import { DocumentosCliente } from '../../components/Cliente/Crud/Tabs/Documentos/DocumentosCliente';
import CrudClienteProvider from '../../store/Cliente/V2/Crud/CrudClienteProvider';
import { EmailsProcesso } from './EmailsProcesso/EmailsProcesso';

function InspecionarProcessoPageComponent() {
  const dispatch = useDispatch();
  const history = useHistory();

  const historicoRef = useRef();

  const [currentTabSelected, setCurrentTabSelected] = useState({
    tabIndex: 0,
    processo: { id: null, key: uuid() },
  });
  const [idsProcessos, setIdsProcessos] = useState([]);
  const [additionalInfos, setAdditionalInfos] = useState({});

  const [fases, setFases] = useState([]);
  const [fasesIds, setFasesIds] = useState(null);

  const [tabKey, setTabKey] = useState(uuid().slice(4));
  const [actionsButtons, setActionsButtons] = useState(
    controller.makeActionsButtons()
  );
  const [listaPreferencias, setListaPreferencias] = useState([]);
  const [visibilidadePreferencias, setVisibilidadePreferencias] = useState({});
  const [fasesTimeline, setFasesTimeline] = useState([]);

  const mutableSelector = useSelector(controller.makeMuttableSelectors);
  const immutableSelectors = useSelector(controller.makeImmutableSelectors);
  const loadingSelectors = useSelector(controller.makeLoadingSelectors);
  const [cliente, setCliente] = useState(null);
  const [devedor, setDevedor] = useState(null);
  const [devedorWarnings, setDevedorWarnings] = useState(null);
  const [clientePermiteUnificar, setClientePermiteUnificar] = useState(false);
  const [dadosProcesso, setDadosProcesso] = useState({});
  const [redirect, setRedirect] = useState('');
  const [disabledAntecedentes, setDisabledAntecedentes] = useState(false);

  const [atualizarAcordos, setAtualizarAcordos] = useState(false);

  const [loadings, setLoadings] = useState(loadingController.makeLoadings());

  const hasIdsProcessos = useCallback(
    () => !idsProcessos && idsProcessos.length > 0,
    [idsProcessos]
  );

  const [tabItens] = useState([
    new TabModel(
      `${tabKey}-resumo`,
      0,
      'Acompanhamento',
      'scrollable-auto-tabpanel',
      false,
      2
    ),
    new TabModel(
      `${tabKey}-titulos`,
      1,
      'Títulos',
      'scrollable-auto-tabpanel',
      false,
      6
    ),
    new TabModel(
      `${tabKey}-antecedente`,
      2,
      'Antecedentes',
      'scrollable-auto-tabpanel',
      false,
      5
    ),
    new TabModel(
      `${tabKey}-devedor`,
      3,
      'Dados do Devedor',
      'scrollable-auto-tabpanel',
      false,
      4
    ),
    new TabModel(
      `${tabKey}-cliente`,
      4,
      'Dados do Cliente',
      'scrollable-auto-tabpanel',
      false,
      3
    ),
    new TabModel(
      `${tabKey}-historico`,
      5,
      'Histórico',
      'scrollable-auto-tabpanel',
      false,
      1
    ),
    new TabModel(
      `${tabKey}-emails`,
      6,
      'E-mails',
      'scrollable-auto-tabpanel',
      false,
      14
    ),
    new TabModel(
      `${tabKey}-acordos`,
      7,
      'Acordos',
      'scrollable-auto-tabpanel',
      false,
      11
    ),
    new TabModel(
      `${tabKey}-recalculo-processo`,
      8,
      'Recálculos do Processo',
      'scrollable-auto-tabpanel',
      false,
      10
    ),
    new TabModel(
      `${tabKey}-documento-processo`,
      9,
      'Documentos do Processo',
      'scrollable-auto-tabpanel',
      false,
      8
    ),
    new TabModel(
      `${tabKey}-ficha-financeira`,
      10,
      'Ficha Financeira',
      'scrollable-auto-tabpanel',
      false,
      9
    ),
    new TabModel(
      `${tabKey}-dados-juridicos`,
      11,
      'Dados Jurídicos',
      'scrollable-auto-tabpanel',
      false,
      12
    ),
    new TabModel(
      `${tabKey}-fases`,
      12,
      'Fases',
      'scrollable-auto-tabpanel',
      false,
      7
    ),
    new TabModel(
      `${tabKey}-documentos-cliente`,
      13,
      'Documentos do Cliente',
      'scrollable-auto-tabpanel',
      false,
      13
    ),
  ]);

  const [activeTab, setActiveTab] = useState(0);

  const changeTabViewHandler = useCallback(
    (activeTabParam) => {
      setActiveTab(activeTabParam);
    },
    [setActiveTab]
  );

  const chooseIdProcesso = useCallback(
    (e, newValue) => {
      if (hasIdsProcessos() && !idsProcessos[newValue]) {
        return;
      }
      setTabKey(uuid().slice(4));
      setCurrentTabSelected({
        tabIndex: newValue,
        processo: { id: idsProcessos[newValue], key: uuid() },
      });
    },
    [hasIdsProcessos, idsProcessos]
  );

  function runActionButtonByTag(tag) {
    return () => {
      setActionsButtons(controller.changeActionButton(actionsButtons, tag));
    };
  }

  const updatePage = useCallback(() => {
    historicoRef.current.moveScrollToTop();
    setCurrentTabSelected({
      ...currentTabSelected,
      processo: { ...currentTabSelected.processo, key: uuid() },
    });
    setActionsButtons(controller.makeActionsButtons(additionalInfos));
  }, [currentTabSelected, additionalInfos]);

  const getActionProps = useCallback(
    (action) => {
      const defaultProps = {
        processo: currentTabSelected.processo,
        setLoadings,
        updatePage,
        setAtualizarAcordos,
      };

      return actionProps[action.tag].makeActionProps(defaultProps, {
        tiposHistorico: immutableSelectors.tiposHistorico,
        tiposAgendamentos: immutableSelectors.tiposAgendamentos,
        requisicoes: immutableSelectors.requisicoes,
        podeModificarFase: additionalInfos.podeModificarFase,
        temPermissaoAtenderRequisicao:
          !additionalInfos?.temPermissaoAtenderRequisicao,
        motivosBaixa: immutableSelectors.motivosBaixa,
        tipoTitulo: immutableSelectors.tipoTitulo,
        permiteCobrancaPresencial:
          additionalInfos?.sinalizacaoClienteProcessoQuery
            .permiteCobrancaPresencial,
        fases,
        idFasePastaAtual: additionalInfos.idFasePasta || '',
        temAgendamento: additionalInfos.temAgendamento,
        idFaseAtual: Number(additionalInfos.idFase),
        idMotivoBaixa: additionalInfos?.idMotivoBaixa || '',
        idNegociador: additionalInfos?.idNegociador || '',
        idProcesso: currentTabSelected.processo.id,
        tiposTitulosAgendamentos: immutableSelectors.tiposTitulosAgendamentos,
        setLoadings,
        clientePermiteUnificar,
        dadosProcesso,
        updatePage,
        fasesIds,
        disabledAntecedentes,
        podeReenviarWhatsapp: additionalInfos?.podeReenviarWhatsapp || '',
        setAtualizarAcordos,
      });
    },
    [
      currentTabSelected,
      immutableSelectors,
      additionalInfos,
      fases,
      updatePage,
      clientePermiteUnificar,
      dadosProcesso,
      fasesIds,
      disabledAntecedentes,
      setAtualizarAcordos,
    ]
  );

  const loadListaPreferencias = useCallback(async () => {
    setLoadings(loadingController.changeLoadingListaPreferencias(true));

    const res = await controller.findPreferencias();
    setListaPreferencias(res.preferencias);
    setVisibilidadePreferencias(res.visibilidadePreferencias);

    setLoadings(loadingController.changeLoadingListaPreferencias(false));
  }, []);

  const tabsIdsProcessos = useMemo(() => {
    const items = controller.makeIdsProcessosTab(idsProcessos);
    if (items.length === 0) {
      return [];
    }
    return items;
  }, [idsProcessos]);

  const onCopiarNroProcesso = useCallback((nome) => {
    navigator.clipboard.writeText(nome);
  }, []);

  const onFecharAbaProcesso = useCallback(
    (e, nome) => {
      const lista = idsProcessos.filter(
        (id) => id.toString() !== nome.replaceAll('.', '')
      );
      setIdsProcessos(lista);
      chooseIdProcesso(e, 0);
      setCurrentTabSelected({
        tabIndex: 0,
        processo: { id: lista[0], key: uuid() },
      });
    },
    [idsProcessos, setIdsProcessos, chooseIdProcesso, setCurrentTabSelected]
  );

  const loading = useMemo(() => controller.isLoading(loadings), [loadings]);

  // function voltarParaPaginaAnterior() {
  // const previousUrl = localStorage.getItem('previousUrl');
  // if (previousUrl) {
  //  localStorage.removeItem('previousUrl'); // Remova a URL armazenada para evitar reutilização acidental
  //  history.push(previousUrl);
  // } else {
  // Caso não haja URL anterior, você pode redirecionar para uma página padrão ou tratar conforme necessário.
  // history.push('/processos');
  // }
  // }

  /**
   * Carregas processos que serão exibidos para serem selecionados
   */
  useEffect(() => {
    const idProcessoQuery = new URLSearchParams(history.location.search).get(
      'nroProcesso'
    );
    let ids = [];
    if (idProcessoQuery) {
      ids = [Number(idProcessoQuery)];
    } else {
      const idsProcessoSession = sessionStorage.getItem('idsProcessos');
      ids = JSON.parse(idsProcessoSession);
    }

    if (ids?.length > 0) {
      setIdsProcessos(ids);
      setCurrentTabSelected({
        tabIndex: 0,
        processo: { id: ids[0], key: uuid() },
      });
    } else {
      history.replace('/processos');
    }
  }, [history]);

  /**
   * Carregar informações que dependem do id do processo
   */
  useEffect(() => {
    if (!currentTabSelected.processo.id) {
      return;
    }

    setLoadings(loadingController.changeLoadingProcessoInfo(true));
    controller
      .loadMutableInfo(currentTabSelected.processo.id)
      .then((res) => {
        setCliente(res.cliente);
        setDevedor(res.devedor);
        setDevedorWarnings(res.devedorWarnings);
        setAdditionalInfos(res.infoProcesso);
        setActionsButtons(res.actionsButtons);
        setFasesTimeline(res.fasesTimeline);
        loadListaPreferencias().then();
        setClientePermiteUnificar(res.infoProcesso.permitirUnificarProcesso);
        setDadosProcesso(res.dadosProcesso);
      })
      .finally(() => {
        setLoadings(loadingController.changeLoadingProcessoInfo(false));
      });
  }, [dispatch, currentTabSelected, loadListaPreferencias]);

  /**
   * Carregar informações que somente serão inicializadas uma unica vez
   */
  useEffect(() => {
    dispatch(initializePageAction('Inspecionar'));

    setLoadings(loadingController.changeLoadingStartPage(true));
    controller
      .loadImmutableInfo()
      .then((res) => {
        setFases(res.fases);
      })
      .finally(() => {
        setLoadings(loadingController.changeLoadingStartPage(false));
      });
  }, [dispatch, loadListaPreferencias]);

  useEffect(() => {
    const fetchFasesData = async () => {
      try {
        const responseFaseBaixa = await buscarIdFaseBaixa();
        const responseFaseAcordoSeguro = await buscarIdFaseAcordoSeguro();

        setFasesIds({
          idFaseAcordoSeguro: responseFaseAcordoSeguro.data,
          idFaseBaixa: responseFaseBaixa.data,
        });
      } catch (error) {
        toast.error(error.response.data);
      }
    };

    fetchFasesData();
  }, []);

  useEffect(() => {
    const previousUrl = localStorage.getItem('previousUrl');
    setRedirect(previousUrl);
  }, [redirect]);

  return (
    <>
      <LoadingUI show={loadingSelectors || loading} />
      <MainContainer>
        <TabsUi
          items={tabsIdsProcessos}
          value={currentTabSelected.tabIndex}
          onChange={chooseIdProcesso}
          onCopiarNroProcesso={onCopiarNroProcesso}
          onFecharAbaProcesso={onFecharAbaProcesso}
        />
        <AdditionalInfoContainer>
          <div style={{ display: 'flex', width: '100%', height: 'inherit' }}>
            <SinalizacaoCores
              idProcesso={currentTabSelected?.processo?.id}
              sinalizacaoCoresQuery={additionalInfos?.sinalizacaoCoresQuery}
              podeModificarFase={additionalInfos?.podeModificarFase}
              setLoadings={setLoadings}
              setAdictionalInfos={setAdditionalInfos}
              permitirAjuizarProcesso={additionalInfos?.permitirAjuizarProcesso}
            />
            <ActionContainer>
              <ActionButtonGroup>
                <div style={{ width: '20%', display: 'flex' }}>
                  {actionsButtons.map((actions) => (
                    <div key={actions.key} style={{ marginRight: '8px' }}>
                      <TooltipUI title={actions.label} placement="bottom">
                        <div>
                          <ActionButton
                            active={actions.active.toString()}
                            disabled={actions.disabled}
                            onClick={runActionButtonByTag(actions.tag)}
                          >
                            <actions.Icon size={16} style={actions.styles} />
                          </ActionButton>
                        </div>
                      </TooltipUI>
                    </div>
                  ))}
                </div>
              </ActionButtonGroup>
            </ActionContainer>
            <SinalizacaoAlertas
              sinalizacaoAlertasQuery={additionalInfos?.sinalizacaoAlertasQuery}
            />

            <div
              style={{
                width: '20%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PreferenciasProcesso
                listaPreferencias={listaPreferencias}
                loadListaPreferencias={loadListaPreferencias}
                setLoadings={setLoadings}
              />
            </div>
            <SinalizacaoIcones
              idProcesso={currentTabSelected?.processo?.id}
              sinalizacaoClienteProcessoQuery={
                additionalInfos?.sinalizacaoClienteProcessoQuery
              }
              podeModificarFase={additionalInfos?.podeModificarFase}
              setLoadings={setLoadings}
              setAdictionalInfos={setAdditionalInfos}
            />
          </div>
        </AdditionalInfoContainer>

        <Container>
          {actionsButtons
            .filter((action) => action.active === true)
            .map((action) => (
              <ActionContentContainer key={action.tag}>
                <action.Content {...getActionProps(action)} />
              </ActionContentContainer>
            ))}

          <TabCardLayout
            tabItems={tabItens}
            parentStates={[activeTab, changeTabViewHandler]}
            devedorWarnings={devedorWarnings}
            visibilidadePreferencias={visibilidadePreferencias}
          >
            {visibilidadePreferencias[2] && (
              <TabPanel
                id={tabItens[0].id}
                index={tabItens[0].index}
                value={activeTab}
              >
                <AcompanhamentoProcesso
                  processo={currentTabSelected.processo}
                  setLoadings={setLoadings}
                  dadosProcesso={dadosProcesso}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[6] && (
              <TabPanel
                id={tabItens[1].id}
                index={tabItens[1].index}
                value={activeTab}
              >
                <TitulosProcesso
                  processo={currentTabSelected.processo}
                  setLoadings={setLoadings}
                  idFaseProcesso={additionalInfos.idFase}
                  sinalizacaoCoresQuery={additionalInfos?.sinalizacaoCoresQuery}
                  updatePage={updatePage}
                  immutableSelectors={immutableSelectors}
                  additionalInfos={additionalInfos.estadoDoDevedor}
                  fasesIds={fasesIds}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[5] && (
              <TabPanel
                id={tabItens[2].id}
                index={tabItens[2].index}
                value={activeTab}
              >
                <AntecedenteProcesso
                  idProcesso={currentTabSelected.processo.id}
                  setLoadings={setLoadings}
                  clientePermiteUnificar={clientePermiteUnificar}
                  dadosProcesso={dadosProcesso}
                  updatePage={updatePage}
                  podeModificarFase={additionalInfos?.podeModificarFase}
                  idFaseProcesso={additionalInfos.idFase}
                  fasesIds={fasesIds}
                  accordion
                  setDisabledAntecedentes={setDisabledAntecedentes}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[4] && (
              <TabPanel
                id={tabItens[3].id}
                index={tabItens[3].index}
                value={activeTab}
              >
                <DadosDevedorProcesso
                  devedor={devedor}
                  podeModificarFase={additionalInfos?.podeModificarFase}
                  immutableSelectors={immutableSelectors}
                  idProcesso={currentTabSelected.processo.id}
                  setLoadings={setLoadings}
                  updatePage={updatePage}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[3] && (
              <TabPanel
                id={tabItens[4].id}
                index={tabItens[4].index}
                value={activeTab}
              >
                <DadosClienteProcesso
                  cliente={cliente}
                  podeModificarFase={additionalInfos?.podeModificarFase}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[1] && (
              <TabPanel
                id={tabItens[5].id}
                index={tabItens[5].index}
                value={activeTab}
              >
                <Historico
                  ref={historicoRef}
                  processo={currentTabSelected.processo}
                  numeroDias={additionalInfos.numeroDiasDataHistorico}
                  podeModificarFase={additionalInfos.podeModificarFase}
                  autores={mutableSelector.autoresHistoricos}
                  fases={fases}
                  tiposHistorico={immutableSelectors.tiposHistorico}
                  setLoadings={setLoadings}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[14] && (
              <TabPanel
                id={tabItens[6].id}
                index={tabItens[6].index}
                value={activeTab}
              >
                <EmailsProcesso
                  ref={historicoRef}
                  processo={currentTabSelected.processo}
                  idComercialPrincipal={cliente?.idUsuarioComercial}
                  setLoadings={setLoadings}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[11] && (
              <TabPanel
                id={tabItens[7].id}
                index={tabItens[7].index}
                value={activeTab}
              >
                <Acordos
                  podeModificarFase={additionalInfos?.podeModificarFase}
                  setLoadings={setLoadings}
                  idProcesso={currentTabSelected.processo.id}
                  idFaseProcesso={additionalInfos.idFase}
                  dadosProcesso={dadosProcesso}
                  sinalizacaoCoresQuery={additionalInfos?.sinalizacaoCoresQuery}
                  updatePage={updatePage}
                  atualizarAcordos={atualizarAcordos}
                  setAtualizarAcordos={setAtualizarAcordos}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[10] && (
              <TabPanel
                id={tabItens[8].id}
                index={tabItens[8].index}
                value={activeTab}
              >
                <ListaRecalculoProcesso
                  processoIdsWithUpdater={currentTabSelected.processo}
                  setLoadings={setLoadings}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[8] && (
              <TabPanel
                id={tabItens[9].id}
                index={tabItens[9].index}
                value={activeTab}
              >
                <DocumentosProcesso
                  idProcesso={currentTabSelected.processo.id}
                  podeModificarFase={additionalInfos?.podeModificarFase}
                  setLoadings={setLoadings}
                  updatePage={updatePage}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[9] && (
              <TabPanel
                id={tabItens[10].id}
                index={tabItens[10].index}
                value={activeTab}
              >
                <FichaFinanceira
                  setLoadings={setLoadings}
                  idProcesso={currentTabSelected.processo.id}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[12] && (
              <TabPanel
                id={tabItens[11].id}
                index={tabItens[11].index}
                value={activeTab}
              >
                <DadosJuridicos
                  idProcesso={currentTabSelected.processo.id}
                  cobrancaJudicial={
                    additionalInfos?.sinalizacaoCoresQuery?.cobrancaJudicial
                  }
                  updatePage={updatePage}
                />
              </TabPanel>
            )}
            {visibilidadePreferencias[7] && (
              <TabPanel
                id={tabItens[12].id}
                index={tabItens[12].index}
                value={activeTab}
              >
                <FaseProcesso fasesTimeline={fasesTimeline} />
              </TabPanel>
            )}
            {visibilidadePreferencias[13] && (
              <TabPanel
                id={tabItens[13].id}
                index={tabItens[13].index}
                value={activeTab}
              >
                <CrudClienteProvider>
                  <DocumentosCliente
                    isEditMode={false}
                    isInsertMode={false}
                    idCliente={cliente?.idCliente}
                    isDisplayMode
                    podeModificarFase={additionalInfos?.podeModificarFase}
                  />
                </CrudClienteProvider>
              </TabPanel>
            )}
          </TabCardLayout>
        </Container>
      </MainContainer>
      {redirect !== '' ? (
        <FooterInspecionar>
          <ButtonUI onClick={() => history.replace(redirect)}>Voltar</ButtonUI>
        </FooterInspecionar>
      ) : (
        <FooterInspecionar>
          <ButtonUI onClick={() => history.replace('/processos')}>
            Voltar
          </ButtonUI>
        </FooterInspecionar>
      )}
    </>
  );
}

export const InspecionarProcessoPage = InspecionarProcessoPageComponent;
